var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"padding-bottom":"18px"}},[(_vm.showAlert)?_c('UnverifiedAlert',{on:{"closeUnverified":function($event){_vm.closeAlert = true}}}):_vm._e(),_c('transition',{attrs:{"name":"slide-x-transition","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }